import type { ReactNode } from "react";
import classNames from "classnames";

interface FooterProps {
  children?: ReactNode;
  sticky?: boolean;
}

export const Footer = ({ sticky, children }: FooterProps) => (
  <div
    className={classNames("drawer__footer", {
      "drawer__footer--sticky": sticky,
    })}
  >
    {children}
  </div>
);
